import styled from 'styled-components';
import { BLACK, GRAYSCALE_400, GRAYSCALE_500, LIGHT_BLUE, NEUTRAL_100, PRIMARY, WHITE } from '../../styles/colors';
import { INTER } from '../../styles/fonts';
import tokenIcon from '../../assets/icons/StackedPurpleCoins.svg';

export const TokenIcon = (styled.img.attrs({ src: tokenIcon })``) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Container = (styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  border: 1px solid ${LIGHT_BLUE};
  padding: 16px;
  border-radius: 16px;
  background-color: #fafdff80;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const IconContainer = (styled.div`
  padding: 0;
  margin: 0;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ContentContainer = (styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 5px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Title = (styled.p`
  padding: 0;
  margin: 0;
  font-family: ${INTER.bold};
  font-size: 13px;
  color: ${BLACK};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Description = (styled.p`
  padding: 0;
  margin: 0;
  font-family: ${INTER.regular};
  font-size: 13px;
  color: ${GRAYSCALE_500};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ActionContainer = (styled.div`
  display: flex;
  flex-direction: row;
  color: ${PRIMARY};
  font-family: ${INTER.medium};
  align-items: center;
  gap: 4px;
  cursor: pointer;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ChevronContainer = (styled.div`
  display: flex;
  align-items: center;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// BottomSheet Content Styles
export const BottomSheetContent = (styled.div.attrs({
  className: 'hide-scrollbar',
})`
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  max-height: calc(85vh - 160px); /* Account for header and fixed button area */
  padding-bottom: 80px; /* Space for the fixed button group */
  ms-overflow-style: none;
  scrollbar-width: none;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// Card Container
export const CardContainer = (styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// Card subcomponents
export const BodyContainer = (styled.div`
  padding: 16px 12px;
  gap: 16px;
  display: flex;
  flex-direction: column;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const FooterContainer = (styled.div`
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid ${NEUTRAL_100};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const FooterText = (styled.span`
  color: ${GRAYSCALE_400};
  font-family: ${INTER.regular};
  text-align: center;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// Fixed Button Containers
export const FixedButtonContainer = (styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 12px 24px 12px;
  background-color: ${WHITE};
  border-top: 1px solid ${NEUTRAL_100};
  z-index: 1;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ButtonGroupContainer = (styled.div`
  display: flex;
  gap: 16px;
  flex-direction: row;
  width: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
